import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import _com from "../../../assets/js/common";
import _intercept from "../../../assets/js/intercept";
import Progress from 'element-ui/lib/progress';
import 'element-ui/lib/theme-chalk/progress.css';

Vue.component('el-progress', Progress)

@Component
export default class leftModal extends Vue {
    @Prop() diff: any = 0
    msg: any = '讲解中'
    difference: number = 0;//本地时间与服务器时间差值
    get goodsList() {
        //商品数据
        let goods = this.$store.getters["refresh/getGoodsList"];
        return this.recommendList(goods);
    }
    @Watch("diff") // 更新接收的值  ，不然只会显示第一次接收到的值
    watchDiff(newVal: number) {
        this.difference = newVal;
    }
    recommendList(data: any) {
        let newData:any = JSON.parse(JSON.stringify(data))
        if (JSON.stringify(newData) === '{}' || newData.length < 1) {
            return false
        } else {
            let nowTimes: number = new Date().getTime() + this.difference;
            newData.forEach((item: any) => {
                if (item.endTime) { // 是否是秒杀
                    if (nowTimes < item.startTime) { // 小于开始时间---未开始
                        item.status = 0
                    } else if (nowTimes >= item.startTime && nowTimes < item.endTime) { // 大于开始时间小于结束时间----已开始
                        item.status = 1
                    } else { // 大于结束时间---已结束
                        item.status = 2
                    }
                }
            });
            newData = newData.sort(() => Math.random() - 0.5)
            this.$emit('activeGoods',newData[0])
			this.$forceUpdate()
            return newData
        }
    }
}
